/* Kyzen inner pages — sort, filters, product gallery, variant picker, quantity steppers. */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function money(el, text) {
    if (el && typeof text === 'string') el.textContent = text;
  }

  ready(function () {
    /* ---------- Sort dropdowns (collection + search) ---------- */
    document.querySelectorAll('[data-ky-sort-form]').forEach(function (form) {
      var select = form.querySelector('[data-ky-sort]');
      if (!select) return;
      select.addEventListener('change', function () {
        form.submit();
      });
    });

    /* ---------- Filter panel (mobile drawer) ---------- */
    var filterbar = document.querySelector('[data-ky-filterbar]');
    if (filterbar) {
      var openFilters = filterbar.querySelector('[data-ky-filter-toggle]');
      var closers = filterbar.querySelectorAll('[data-ky-filter-close]');

      function setFilters(open) {
        document.body.classList.toggle('ky-filters-open', open);
        if (openFilters) openFilters.setAttribute('aria-expanded', String(open));
      }

      if (openFilters) {
        openFilters.addEventListener('click', function () {
          setFilters(!document.body.classList.contains('ky-filters-open'));
        });
      }
      closers.forEach(function (btn) {
        btn.addEventListener('click', function () {
          setFilters(false);
        });
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && document.body.classList.contains('ky-filters-open')) setFilters(false);
      });

      /* Only one filter popover open at a time on desktop. */
      var groups = filterbar.querySelectorAll('[data-ky-filter-group]');
      groups.forEach(function (group) {
        group.addEventListener('toggle', function () {
          if (!group.open) return;
          if (window.matchMedia('(max-width: 860px)').matches) return;
          groups.forEach(function (other) {
            if (other !== group) other.open = false;
          });
        });
      });

      document.addEventListener('click', function (event) {
        if (window.matchMedia('(max-width: 860px)').matches) return;
        if (filterbar.contains(event.target)) return;
        groups.forEach(function (group) {
          group.open = false;
        });
      });
    }

    /* ---------- Quantity steppers (product + cart lines) ---------- */
    document.querySelectorAll('.ky-qty-control').forEach(function (control) {
      var input = control.querySelector('input');
      if (!input) return;
      control.querySelectorAll('[data-ky-qty],[data-ky-line-qty]').forEach(function (button) {
        button.addEventListener('click', function () {
          var step = parseInt(button.getAttribute('data-ky-qty') || button.getAttribute('data-ky-line-qty'), 10) || 0;
          var min = parseInt(input.getAttribute('min'), 10);
          if (isNaN(min)) min = 0;
          var next = (parseInt(input.value, 10) || 0) + step;
          if (next < min) next = min;
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* ---------- Product page ---------- */
    var productRoot = document.querySelector('[data-ky-product]');
    if (!productRoot) return;

    /* Gallery thumbnails */
    var mainImage = document.getElementById('KyzenProductImage');
    var thumbs = productRoot.querySelectorAll('[data-ky-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImage) return;
        mainImage.src = thumb.getAttribute('data-ky-thumb');
        thumbs.forEach(function (other) {
          other.classList.toggle('on', other === thumb);
        });
      });
    });

    /* Variant picker */
    var dataScript = productRoot.querySelector('[data-ky-variant-data]');
    var picker = productRoot.querySelector('[data-ky-variant-picker]');
    var idInput = productRoot.querySelector('[data-ky-variant-id]');
    var addButton = productRoot.querySelector('[data-ky-add]');
    var addLabel = productRoot.querySelector('[data-ky-add-label]');
    var priceEl = productRoot.querySelector('[data-ky-price] strong');
    var compareEl = productRoot.querySelector('[data-ky-price] s');
    var availabilityEl = productRoot.querySelector('[data-ky-availability]');

    if (dataScript && picker && idInput) {
      var variants = [];
      try {
        variants = JSON.parse(dataScript.textContent);
      } catch (error) {
        variants = [];
      }

      var soldOutLabel = 'Sold out';
      var inStockLabel = addLabel ? addLabel.textContent.trim() : 'Add to cart';

      function selectedOptions() {
        var chosen = [];
        picker.querySelectorAll('.ky-variant-option').forEach(function (group, index) {
          var checked = group.querySelector('input[type="radio"]:checked');
          chosen[index] = checked ? checked.value : null;
        });
        return chosen;
      }

      function update() {
        var chosen = selectedOptions();
        var match = variants.find(function (variant) {
          return chosen.every(function (value, index) {
            return value === null || variant.options[index] === value;
          });
        });

        if (!match) {
          if (addButton) addButton.disabled = true;
          money(addLabel, 'Unavailable');
          money(availabilityEl, 'Unavailable');
          return;
        }

        idInput.value = match.id;
        money(priceEl, match.price);

        if (compareEl) compareEl.style.display = match.has_compare ? '' : 'none';
        if (compareEl && match.has_compare) money(compareEl, match.compare_at_price);

        if (match.image && mainImage) {
          mainImage.src = match.image;
          thumbs.forEach(function (other) {
            other.classList.toggle('on', other.getAttribute('data-ky-thumb') === match.image);
          });
        }

        if (addButton) addButton.disabled = !match.available;
        money(addLabel, match.available ? inStockLabel : soldOutLabel);
        money(availabilityEl, match.available ? 'In stock' : 'Sold out');

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      picker.addEventListener('change', update);
    }

    /* Preorder acknowledgement gate */
    var form = document.getElementById('KyzenProductForm');
    var agree = productRoot.querySelector('[data-ky-agree]');
    var agreeError = productRoot.querySelector('[data-ky-agree-error]');
    if (form && agree) {
      form.addEventListener('submit', function (event) {
        if (!agree.checked) {
          event.preventDefault();
          if (agreeError) agreeError.hidden = false;
          agree.focus();
        }
      });
      agree.addEventListener('change', function () {
        if (agree.checked && agreeError) agreeError.hidden = true;
      });
    }
  });
})();
